export default __webpack_public_path__ + "static/media/carbon_add-filled.4dd6ef5a.svg";